var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mobile-float-menu',{attrs:{"header":""},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"container"},[_c('LanguageLoader',{attrs:{"routeLanguage":"./translations/faqs/faqs_"}})],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }